<template>
    <notifications group="alert"
                   class="notification"
                   position="top right">
        <template slot="body"
                  slot-scope="{ item, close }">
            <div class="notify">
                <button class="close px-1"
                        @click="close">
                    <b-icon-x />
                </button>
                <div class="title pl-3 pr-4 py-3">
                    <b-icon-check2-circle v-if="item.type == 'success'"
                                          class="mr-1 icon" />
                    <b-icon-exclamation-circle v-if="item.type == 'error'"
                                               class="mr-1 icon" /> {{item.title}}
                    <p v-html="item.text"></p>
                </div>
            </div>
        </template>
    </notifications>
</template>

<script>
export default {
    name: 'Notification',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notify {
    background-color: #ffefe2;
    color: #666;
    position: relative;
    border-radius: 6px;
    margin-top: 10px;
    margin-bottom: 5px;
    margin-right: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    .icon {
        color: #f3a447;
        font-size: 1.0625rem;
    }
    &::before {
        content: '';
        background: linear-gradient(to bottom, #ff8d2b, #ffa65a);
        height: 100%;
        width: 3px;
        top: 0;
        position: absolute;
        border-radius: 6px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
}
</style>
